import { useContext, useEffect, useRef, useState } from 'react';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { UserOrderContext } from 'context/context';
import { BRAZE_ACCOUNT_MSG } from 'common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
const { MESSAGES_TAG } = TRANSLATE_MAPPING_KEY;

const MessagePage = props => {
  const { isMobile } = props;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const [messageCount, setMessageCount] = useState(0);
  const [newMsgCount, setNewMsgCount] = useState(0);
  const oldCount = useRef();
  const { accountCardLength } = userOrderState;
  const { SingleArrowback } = IMAGE_PATH;

  useEffect(() => {
    const msgWrapper = document.getElementById('message-wrapper');
    oldCount.current = newMsgCount;
    window?.appboy?.requestContentCardsRefresh();
    userOrderStateDispatch({
      type: BRAZE_ACCOUNT_MSG,
      value: { accountCardLength: accountCardLength },
    });
    setNewMsgCount(accountCardLength);
    setMessageCount(oldCount.current);
    window?.appboy?.display?.showContentCards(msgWrapper);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountCardLength, userOrderStateDispatch]);

  return (
    <div data-testid='account-message-wrapper' className='account-message-wrapper'>
      {isMobile && (
        <div className='account-message-header-mobile'>
          <img
            className='backArrow-account-setting'
            data-testid='message-backArrow'
            onClick={() => props.updateMenu('')}
            src={SingleArrowback}
            alt='back button'
          />
          <span className='account-message-text-header'>{translateWithI18Next(MESSAGES_TAG)}</span>
        </div>
      )}
      <span className='account-message-text-heading'>
        {translateWithI18Next(MESSAGES_TAG)} {!!messageCount && `(${messageCount})`}
      </span>
      <div id='message-wrapper'></div>
    </div>
  );
};

export default MessagePage;
